module.exports = __webpack_public_path__ + "img/7_80.3dfdd9b6.png";